import { ReactNode } from "react";

const ActionBar = ({ children }: { children: ReactNode }) => (
  <div className="fixed bottom-4 right-0 md:right-4 w-full md:w-[calc(100%-16rem)] px-4 z-40">
    <div className="bg-white flex px-4 py-2 rounded-lg shadow gap-4 border-2 border-gray-100">
      {children}
    </div>
  </div>
);

export default ActionBar;
